"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hubCustomFont = exports.hubPrimaryColor = exports.is_admin = exports.advocate_to_advocate_enabled = void 0;

var R = _interopRequireWildcard(require("ramda"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

// Defaults used for testing environment.
var _a2a_enabled = true;
var _is_admin = false; // Needs to be here to avoid node tests from failing
// on access to nonexistant window object.

if (typeof window !== 'undefined') {
  var a2aPath = ['_infl', 'settings', 'hub', 'advocate_to_advocate_enabled'];
  _a2a_enabled = R.pathOr(_a2a_enabled, a2aPath, window);
  _is_admin = R.pathOr(_is_admin, ['_infl', 'currentContact', 'isAdmin'], window);
}

var advocate_to_advocate_enabled = _a2a_enabled;
exports.advocate_to_advocate_enabled = advocate_to_advocate_enabled;
var is_admin = _is_admin;
exports.is_admin = is_admin;
var hubPrimaryColor = R.path(['_inflTheme', 'themeColorPrimary'], window);
exports.hubPrimaryColor = hubPrimaryColor;
var hubCustomFont = R.path(['_inflTheme', 'customFont'], window) || {};
exports.hubCustomFont = hubCustomFont;